export default __webpack_public_path__ + "static/media/rvs_stormband.3f9d4227.png";